const moment = require("moment");
const ActionType = require("../action-types/users");
const Deeply = require("utils/deeply");

const internals = {
    initial: () => ({
        isFetching: false,
        items: null,
        hasFetchedAll: false
    })
};

module.exports = (state, action) => {
    const { type, payload } = action;
    state = state || internals.initial();

    switch (type) {
        case ActionType.DELETE_USER_SUCCESS: {
            const items = [...state.items];
            const index = items.findIndex(u => u.id === payload.id);

            // Remove the user from the user list
            if (index !== -1) {
                items.splice(index, 1);
            }

            return Deeply(state)
                .set("items", items)
                .value();
        }

        case ActionType.FETCH_USERS_BEGIN:
            return Deeply(state)
                .set("isFetching", true)
                .value();

        case ActionType.FETCH_USERS_FAILURE:
            return Deeply(state)
                .set("isFetching", false)
                .value();

        case ActionType.FETCH_USERS_SUCCESS: {
            // Filter out deleted users
            const items = payload.items.filter(u => u.dateDeleted === null);

            return Deeply(state)
                .set("isFetching", false)
                .set("items", items)
                .set("hasFetchedAll", true)
                .value();
        }
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/users.js